var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-name"},_vm._l((_vm.fileExt),function(t,index){return _c('div',{key:index,staticClass:"label"},[_vm._v(_vm._s(t))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }